



































import Loader from '@/components/common/Loader.vue';
import { Component, Vue } from 'vue-property-decorator';
import { accountSettingsService } from '@/services/AccountSettingsService';
import { tokenService } from '@/services/TokenService';

@Component({
  components: { Loader },
})
export default class ChangeEmailConfirmation extends Vue {
  isError = false;
  isLoading = false;
  confirmedEmail = '';
  isNewEmail = false;
  isEmailChanged = false;
  mounted() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    accountSettingsService
      .confirmEmail(this.$route.params.token)
      .then((data: any) => {
        this.isLoading = false;
        if (data && data.confirmed_email) {
          this.confirmedEmail = data.confirmed_email;
          this.isEmailChanged = data.email_changed;
          this.isNewEmail = data.new_email;
          if (data.email_changed) {
            tokenService.removeToken();
          }
        } else {
          this.isError = true;
        }
      })
      .catch(() => {
        this.isLoading = false;
        this.isError = true;
      });
  }
}
